export default "__VITE_ASSET__21011fdb__"